export default {
  showModal(state, { modal, modalOptions }) {
    document.body.setAttribute("data-modal", true);
    state.modalIsVisible = true;
    state.activeModal = modal;
  },
  hideModal(state) {
    document.body.removeAttribute("data-modal");
    state.modalIsVisible = false;
    state.activeModal = null;
  },
  setToken(state, { token }) {
    state.user.token = token;
  },
  setBtUuid(state, { uuid }) {
    state.btUuid = uuid;
  },
  setUserEmail(state, { email }) {
    state.user.email = email;
  },
  setGuestDetails(state, { email, phone, name }) {
    state.user.email = email;
    state.user.phone = phone;
    state.user.name = name;
  },

  clearState(state) {
    state.requiredCheckoutData = {
      basketId: null,
      btToken: null,
      basketTotal: null,
      promotionDiscount: null,
      voucherDiscount: null,
    };
    state.paymentData = {
      deviceData: null,
      nonce: null,
      description: null,
      paymentType: null,
    };
  },
  clearStatusData(state) {
    state.successData = {
      paidBy: null,
      uniqueRef: null,
    };
    state.failureData = {
      message: null,
    };
  },
  setCheckoutData(
    state,
    { btToken, basketTotal, basketId, promotionDiscount, voucherDiscount }
  ) {
    state.requiredCheckoutData.btToken = btToken;
    state.requiredCheckoutData.basketTotal = basketTotal;
    state.requiredCheckoutData.basketId = basketId;
    state.requiredCheckoutData.promotionDiscount = promotionDiscount;
    state.requiredCheckoutData.voucherDiscount = voucherDiscount;
  },
  setIorderConfig(state, { config }) {
    state.config = config;
  },
  setPaymentError(state, { message }) {
    state.failureData.message = message;
  },
  setTransactionDetails(state, { paidBy, uniqueRef, receiptEmail }) {
    state.successData = { paidBy, uniqueRef, receiptEmail };
  },
  setVoucherDetail(state, { voucherDetail }) {
    state.voucherDetail = voucherDetail;
  },
  setOrderNumber(state, { orderNumber }) {
    state.orderNumber = orderNumber;
  },
};
